import React, { useEffect, useState } from "react";
import api from "APP_ROOT/api";
import { get } from "lodash";
import T from "prop-types";
import { toSentence } from "LIB/formatters/text";
import Warning from "../../../shared/components/Warning/Warning";
import useDebounce from "../../../../hooks/useDebounce";

export default function RestrictedContactWarning({ contact, requireApproval }) {
  if (!contact) return null;

  const [restrictedEntities, setRestrictedEntities] = useState(null);
  const args = useDebounce(500, contact);
  useEffect(
    () => {
      const params = {};
      if (contact) {
        params.name = contact;
      }

      api.restrictedEntities.search(params).then(resp => {
        if (Number(get(resp, "data.total", 0)) > 0) {
          setRestrictedEntities(resp.data.results);
        } else {
          setRestrictedEntities(null);
        }
      });
    },
    [args]
  );

  if (!restrictedEntities) return null;

  return (
    <Warning>
      Warning: Similar entity name in US Gov&apos;t Screening List for selected
      Contact: {toSentence(restrictedEntities.map(f => f.name))}.{" "}
      {requireApproval && "Pre-Approval Required."}
    </Warning>
  );
}

RestrictedContactWarning.propTypes = {
  contact: T.string
};



// WEBPACK FOOTER //
// ./app/modules/companies/shared/components/RestrictedContactWarning.jsx